<script setup>
import { defineProps, defineEmits, watch, ref, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import UtilNumber from "@/utils/UtilNumber";
import UtilRules from "@/utils/UtilRules.mjs";
import UtilMath from "@/utils/UtilMath";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "gerandoRecebimentos",
    "contasFinanceiras",
    "dado",
    "recebimentoNovo"
]);

const emits = defineEmits([
    "update:alteraRecebimentoNovo",
    "update:autocalculaRecebimentoNovo",
    "update:validaRecebimentoNovo",
]);

//==================================================================//
//===================== REF Job Parcela ============================//
//==================================================================//

const refJobParcela = ref("");

//==================================================================//
//================== REF Conta Financeira ==========================//
//==================================================================//

const refContaFinanceira = ref("");

//==================================================================//
//================= Altera Recebimento Novo ========================//
//==================================================================//

const alteraRecebimentoNovo = (update)=>{

    update.id = props?.recebimentoNovo?.id;
    emits('update:alteraRecebimentoNovo',update);

};

//==================================================================//
//================= Autocalcula Recebimento Novo ===================//
//==================================================================//

const autocalculaRecebimentoNovo = (update)=>{

    update.id = props?.recebimentoNovo?.id;
    emits('update:autocalculaRecebimentoNovo',update);

};

//==================================================================//
//=================== Valida Recebimento Novo ======================//
//==================================================================//

const validaRecebimentoNovo = (update)=>{

    update.id = props?.recebimentoNovo?.id;
    emits('update:validaRecebimentoNovo',update);

};

//==================================================================//
//=============== Conta a Receber Valor Original ===================//
//==================================================================//

const contaAReceberValorOriginal = computed(()=>{

    return UtilNumber.toNumber(props?.recebimentoNovo?.contaAReceberValorOriginal);

});

//==================================================================//
//================ Conta a Receber Valor Recebido ==================//
//==================================================================//

const contaAReceberValorRecebido = computed(()=>{

    let valorRecebido = props?.recebimentoNovo?.contaAReceberValorRecebido + props?.recebimentoNovo?.valorRecebimento;

    return UtilNumber.toNumber(valorRecebido);

});

//==================================================================//
//============== Conta a Receber Valor Para Receber ================//
//==================================================================//

const contaAReceberValorParaReceber = computed(()=>{

    let valorParaReceber = props?.recebimentoNovo?.contaAReceberValorParaReceber - props?.recebimentoNovo?.valorRecebimento;

    return UtilNumber.toNumber(valorParaReceber);

});

//==================================================================//
//================= Job Parcela Valor Original =====================//
//==================================================================//

const jobParcelaValorOriginal = computed(()=>{

    return UtilNumber.toNumber(props?.recebimentoNovo?.jobParcela?.valorOriginal);

});

//==================================================================//
//================== Job Parcela Valor Recebido ====================//
//==================================================================//

const jobParcelaValorRecebido = computed(()=>{

    let valorRecebido = props?.recebimentoNovo?.jobParcela?.valorRecebido + props?.recebimentoNovo?.valorRecebimento;

    return UtilNumber.toNumber(valorRecebido);

});

//==================================================================//
//=============== Job Parcela Valor para Receber ===================//
//==================================================================//

const jobParcelaValorParaReceber = computed(()=>{

    let valorParaReceber = props?.recebimentoNovo?.jobParcela?.valorParaReceber - props?.recebimentoNovo?.valorRecebimento;

    return UtilNumber.toNumber(valorParaReceber);

});

//==================================================================//
//========= Cor Conta a Receber Valor Recebido Valido ==============//
//==================================================================//

const contaAReceberValorRecebidoValido = computed(()=>{

    if(contaAReceberValorRecebido.value >= 0 && contaAReceberValorRecebido.value <= contaAReceberValorOriginal.value){
        return true;
    }

    return false;

});

//==================================================================//
//======== Cor Conta a Receber Valor Para Receber Valido ===========//
//==================================================================//

const contaAReceberValorParaReceberValido = computed(()=>{

    if(contaAReceberValorParaReceber.value >= 0 && contaAReceberValorParaReceber.value <= contaAReceberValorOriginal.value){
        return true;
    }

    return false;

});






//==================================================================//
//============ Cor Job Parcela Valor Recebido Valido ===============//
//==================================================================//

const jobParcelaValorRecebidoValido = computed(()=>{

    if(jobParcelaValorRecebido.value >= 0 && jobParcelaValorRecebido.value <= jobParcelaValorOriginal.value){
        return true;
    }

    return false;

});

//==================================================================//
//============= Cor Job Parcela Valor para Receber =================//
//==================================================================//

const jobParcelaValorParaReceberValido = computed(()=>{

    if(jobParcelaValorParaReceber.value >= 0 && jobParcelaValorParaReceber.value <= jobParcelaValorOriginal.value){
        return true;
    }

    return false;

});





//==================================================================//
//================ Porcentagem Recebimento Valido ==================//
//==================================================================//

const porcentagemRecebimentoValido = computed(()=>{

    let porcentagemRecebimento = UtilNumber.toNumber(props?.recebimentoNovo?.porcentagemRecebimento);

    if(UtilNumber.isNotPercentage(porcentagemRecebimento)){
        return false;
    }

    if(porcentagemRecebimento <= 0){
        return false;
    }

    return true;

});

//==================================================================//
//============ Cor Conta a Receber Valor Recebido ==================//
//==================================================================//

const corContaAReceberValorRecebido = computed(()=>{

    if(contaAReceberValorRecebidoValido.value){
        return "green";
    }

    return "red";

});

//==================================================================//
//============ Cor Conta a Receber Valor Para Receber ==============//
//==================================================================//

const corContaAReceberValorParaReceber = computed(()=>{

    if(contaAReceberValorParaReceberValido.value){
        return "green";
    }

    return "red";

});

//==================================================================//
//================ Cor Job Parcela Valor Recebido ==================//
//==================================================================//

const corJobParcelaValorRecebido = computed(()=>{

    if(jobParcelaValorRecebidoValido.value){
        return "green";
    }

    return "red";

});

//==================================================================//
//============= Cor Job Parcela Valor para Receber =================//
//==================================================================//

const corJobParcelaValorParaReceber = computed(()=>{

    if(jobParcelaValorParaReceberValido.value){
        return "green";
    }

    return "red";

});

//==================================================================//
//==================== Desativa Job Parcelas =======================//
//==================================================================//

const desativaJobParcela = computed(() => {

    if(props?.controlesDesativados){
        return true
    }

    if(props?.recebimentoNovo?.autocalculado){
        return true;
    }

    if(props?.recebimentoNovo?.selecionado == false){
        return true;
    }

    return false;

});

//==================================================================//
//================= Desativa Contas Financeiras ====================//
//==================================================================//

const desativaContasFinanceiras = computed(() => {

    if(props?.controlesDesativados){
        return true
    }

    if(props?.recebimentoNovo?.autocalculado){
        return true;
    }

    if(props?.recebimentoNovo?.selecionado == false){
        return true;
    }

    return false;

});

//==================================================================//
//==================== Desativa Autocalcular =======================//
//==================================================================//

const desativaAutocalcular = computed(()=>{

    if(props.controlesDesativados){
        return true;
    }

    if(props?.recebimentoNovo?.selecionado == false){
        return true;
    }

    if(!props?.recebimentoNovo?.jobParcela?.id){
        return true;
    }

    if(!props?.recebimentoNovo?.contaFinanceira?.id){
        return true;
    }

    return false;

});

//==================================================================//
//============== Desativa Porcentagem Recebimento ==================//
//==================================================================//

const desativaPorcentagemRecebimento = computed(()=>{

    if(props.controlesDesativados){
        return true;
    }

    if(props?.recebimentoNovo?.autocalculado){
        return true;
    }

    if(!props?.recebimentoNovo?.jobParcela?.id){
        return true;
    }

    return false;

});

//==================================================================//
//================== Recebimento Novo Valido =======================//
//==================================================================//

const recebimentoNovoValido = computed(()=>{

    // Se não estiver selecionado
    if(props?.recebimentoNovo?.selecionado == false){
        return false;
    }

    // Se Falta a Conta Financeira estiver selecionado
    if(!props?.recebimentoNovo?.contaFinanceira?.id){
        return false;
    }

    // Se Falta o Job Parcela estiver selecionado
    if(!props?.recebimentoNovo?.jobParcela?.id){
        return false;
    }

    // Se Porcentagem do Recebimento for invalido
    if(porcentagemRecebimentoValido.value == false){
        return false
    }

    // Se Conta a Receber Valor do Recebimento for invalido
    if(contaAReceberValorRecebidoValido.value == false){
        return false
    }

    // Se Conta a Receber Valor para Receber for invalido
    if(contaAReceberValorParaReceberValido.value == false){
        return false
    }

    // Se Job Parcela Valor Recebido for invalido
    if(jobParcelaValorRecebidoValido.value == false){
        return false
    }

    // Se Job Parcela Valor para Receber for invalido
    if(jobParcelaValorParaReceberValido.value == false){
        return false
    }

    return true;

});

//==================================================================//
//============== Ao Selecionar Recebimento Novo ====================//
//==================================================================//

const aoSelecionarRecebimentoNovo = ()=>{

    alteraRecebimentoNovo({
        selecionado: !props?.recebimentoNovo?.selecionado,
    })

};

//==================================================================//
//============== Ao Autocalcular Recebimento Novo ==================//
//==================================================================//

const aoAutocalcular = () =>{

    autocalculaRecebimentoNovo({
        autocalculado: !props?.recebimentoNovo?.autocalculado,
        porcentagemRecebimento: 0,
        valorRecebimento: 0,
    })

};

//==================================================================//
//================= Ao Selecionar Parcela Job ======================//
//==================================================================//

const aoSelecionarParcelaJob = (jobParcela = {})=>{

    alteraRecebimentoNovo({
        jobParcela: jobParcela || {},
        porcentagemRecebimento: 0,
        valorRecebimento: 0,
    });

};

//==================================================================//
//============== Ao Selecionar Conta Financeira ====================//
//==================================================================//

const aoSelecionarContaFinanceira = (contaFinanceira = {})=>{

    alteraRecebimentoNovo({
        contaFinanceira: contaFinanceira || {},
    });

};

//==================================================================//
//=========== Ao Alterar Porcentagem Recebimento ===================//
//==================================================================//

const aoAlterarPorcentagemRecebimento = (porcentagemRecebimento = {})=>{

    alteraRecebimentoNovo({
        porcentagemRecebimento: UtilNumber.toNumber(porcentagemRecebimento) || 0,
    });

};

//==================================================================//
//====================== Watch => selecionado ======================//
//==================================================================//

watch(()=> props?.recebimentoNovo?.selecionado, async () => {


    if(props?.recebimentoNovo?.selecionado == false){

        refJobParcela.value.reset();
        refContaFinanceira.value.reset();

    }

});

//==================================================================//
//================= Watch => gerandoRecebimentos ===================//
//==================================================================//

watch(()=> props?.gerandoRecebimentos, async () => {

    if(props?.gerandoRecebimentos == false){

        refJobParcela.value.reset();
        refContaFinanceira.value.reset();

    }

});

//==================================================================//
//================= Watch => recebimentoNovoValido =================//
//==================================================================//

watch(()=> recebimentoNovoValido.value, async () => {

    alteraRecebimentoNovo({
        valido: recebimentoNovoValido.value
    });

});

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__header">

            <h3 class="c-header__checkbox">

                <v-checkbox
                    class="c-checkbox"
                    :value="props?.recebimentoNovo?.selecionado"
                    :disabled="props?.controlesDesativados"
                    @change="aoSelecionarRecebimentoNovo"
                ></v-checkbox>

            </h3>

            <h3 class="c-header__titulo">

                Conta a Receber - {{props?.recebimentoNovo?.contaAReceberCodigo}}

            </h3>

            <div class="c-header__controles">

                <v-btn
                    class="c-botao-autocalcular"
                    color="primary"
                    dark
                    :disabled="desativaAutocalcular"
                    @click="aoAutocalcular"
                >
                    
                    <v-simple-checkbox
                        class="c-botao-autocalcular__checkbox"
                        :value="props?.recebimentoNovo?.autocalculado"
                        :disabled="desativaAutocalcular"
                    ></v-simple-checkbox>

                    Autocalcular

                </v-btn>

            </div>

            <div class="c-header__medidores c-medidores">

                <div class="c-medidor">

                    <v-chip class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        CR - Valor Original:
                        {{UtilMoney.toR$BRL(contaAReceberValorOriginal)}}

                    </v-chip>

                </div>

                <div class="c-medidor">

                    <v-chip class="c-medidor__chip"
                        :color="corContaAReceberValorRecebido"
                        dark
                        label
                    >

                        CR - Valor Liquidado:
                        {{UtilMoney.toR$BRL(contaAReceberValorRecebido)}}

                    </v-chip>

                </div>

                <div class="c-medidor">

                    <v-chip class="c-medidor__chip"
                        :color="corContaAReceberValorParaReceber"
                        dark
                        label
                    >

                        CR - Valor a Liquidar:
                        {{UtilMoney.toR$BRL(contaAReceberValorParaReceber)}}

                    </v-chip>

                </div>

            </div>

        </v-card-title>

        <v-divider></v-divider>

        <div class="c-cartao__body">

            <div class="c-campos c-campos--grid-fit-columns">

                <v-select
                    ref="refJobParcela"
                    label="Parcelas do Job"
                    :items="props?.dado?.jobParcelas"
                    :disabled="desativaJobParcela"
                    outlined
                    clearable
                    hide-details
                    return-object
                    item-value="id"
                    item-text="descricao"
                    @change="aoSelecionarParcelaJob"
                >

                    <template v-slot:item="{ item }">
                        <span> <strong>{{item.codigo}}</strong> - <strong>{{item.tipo}}</strong> - <span>{{item.descricao}}</span> </span>
                    </template>

                    <template v-slot:selection="{ item }">
                        <span> <strong>{{item.codigo}}</strong> - <strong>{{item.tipo}}</strong> - <span>{{item.descricao}}</span> </span>
                    </template>

                </v-select>

                <v-select
                    ref="refContaFinanceira"
                    label="Contas Financeiras"
                    :items="props?.contasFinanceiras"
                    :disabled="desativaContasFinanceiras"
                    outlined
                    clearable
                    hide-details
                    return-object
                    item-value="id"
                    item-text="nome"
                    @change="aoSelecionarContaFinanceira"
                ></v-select>

            </div>

            <div class="c-campos c-campos--flex">

                <div class="c-medidores">

                    <div class="c-medidor">

                        <v-chip class="c-medidor__chip"
                            color="green"
                            dark
                            label
                        >

                            PA - Valor Original:
                            {{UtilMoney.toR$BRL(jobParcelaValorOriginal)}}

                        </v-chip>

                    </div>

                    <div class="c-medidor">

                        <v-chip class="c-medidor__chip"
                            :color="corJobParcelaValorRecebido"
                            dark
                            label
                        >

                            PA - Valor Liquidado:
                            {{UtilMoney.toR$BRL(jobParcelaValorRecebido)}}

                        </v-chip>

                    </div>

                    <div class="c-medidor">

                        <v-chip class="c-medidor__chip"
                            :color="corJobParcelaValorParaReceber"
                            dark
                            label
                        >

                            PA - Valor a Liquidar:
                            {{UtilMoney.toR$BRL(jobParcelaValorParaReceber)}}

                        </v-chip>

                    </div>

                </div>

            </div>

            <v-divider></v-divider>

            <div class="c-campos c-campos--grid-fit-columns">

                <vuetify-money
                    class="c-money"
                    label="Porcentagem Recebimento"
                    type="number"
                    outlined
                    hide-details
                    :value="props?.recebimentoNovo?.porcentagemRecebimento"
                    :disabled="desativaPorcentagemRecebimento"
                    :rules="UtilRules.percentage"
                    :options="{ 
                        'precision': '2'
                    }"
                    :properties="{
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-percent',
                        
                    }"
                    @input="aoAlterarPorcentagemRecebimento"
                ></vuetify-money>

                <vuetify-money
                    class="c-money"
                    type="number"
                    outlined
                    :value="props?.recebimentoNovo?.valorRecebimento"
                    label="Valor Recebimento"
                    disabled
                    hide-details
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                ></vuetify-money>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

/*==================================================================*/
/*========================== Cartão ================================*/
/*==================================================================*/

.c-cartao__header{
    display: grid; 
    grid-template-columns: max-content 1fr max-content; 
    grid-template-rows: max-content max-content; 
    gap: 10px; 
    grid-template-areas: 
        "checkbox titulo controles"
        "medidores medidores medidores";
}

.c-header__checkbox {
    grid-area: checkbox;
}

.c-header__titulo {
    grid-area: titulo;
}

.c-header__controles {
    grid-area: controles;
}

.c-header__medidores{
    grid-area: medidores;
}

.c-cartao__body{
    display: grid;
    grid-gap: 15px;
}

/*==================================================================*/
/*=========================== Botão ================================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-autocalcular{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

.c-botao-autocalcular__checkbox{
    pointer-events: none;
}

/*==================================================================*/
/*========================= Medidores ==============================*/
/*==================================================================*/

.c-medidores{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

/*==================================================================*/
/*========================== Campos ================================*/
/*==================================================================*/

.c-campos--flex{
    display: flex;
}

.c-campos--grid-fit-columns{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 20px;
}

/*==================================================================*/
/*========================= Checkbox ===============================*/
/*==================================================================*/

.c-checkbox >>> .v-icon{
    font-size: 28px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox >>> .v-input__control{
    flex-grow: 0;
    flex-wrap: nowrap;
    min-width: auto;
    width: auto;
}

</style>